// @flow
import * as React from "react"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import Progress from "material-ui/LinearProgress"
import Divider from "material-ui/Divider"
import {CardText} from "material-ui/Card"
import {containers} from "@swarm2/core"
import * as Util from "../common"
import {List, ListItem} from "material-ui/List"

const M = Util.intlMessages("view.CombatRun")
const SM = Util.intlMessages("soldiers")
const ZM = Util.intlMessages("zone")

function CombatRunSoldierItemRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {soldierName, count, hp, maxHp, attackPower} = props
  const primaryText = (
    <div style={{textTransform: "capitalize"}}>
      <M
        id="soldier.name"
        values={{
          soldier: <SM id={soldierName} values={{count}} />,
          count,
          countText: <Util.Num val={count} />,
        }}
      />
    </div>
  )
  return (
    <ListItem
      primaryText={primaryText}
      secondaryText={
        <span style={{color: "inherit"}}>
          {count === 1 ? (
            <Progress mode="determinate" value={hp} max={maxHp} min={0} />
          ) : null}
          <M
            id="soldier.hp"
            values={{
              count,
              maxHp,
              maxHpText: <Util.Num val={maxHp} />,
              hp,
              hpText: <Util.Num val={hp} />,
              attack: attackPower || 0,
              attackText: <Util.Num val={attackPower || 0} />,
            }}
          />
        </span>
      }
    />
  )
}
export const CombatRunSoldierItem = containers.combat.CombatRunSoldierItem(
  CombatRunSoldierItemRender,
)
function CombatRunSoldierList(props) {
  const {charId, clientNow, team, soldiers, title, float} = props
  const names = [...soldiers].reverse()
  return (
    <List style={{width: "45%", float}}>
      <ListItem primaryText={title} disabled />
      <Divider />
      {names.map(name => (
        <CombatRunSoldierItem
          key={name}
          soldierName={name}
          team={team}
          charId={charId}
          clientNow={clientNow}
        />
      ))}
    </List>
  )
}
function CombatRunContentRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    charId,
    clientNow,
    zone,
    playerSoldiers,
    enemySoldiers,
    createdAt,
    doneAt,
    displayName,
  } = props
  return (
    <div>
      <CardText>
        <div style={{textAlign: "center"}}>
          {doneAt ? (
            <Util.Duration millis={doneAt - createdAt} noSuffix />
          ) : (
            <Util.FromNow since={createdAt} noSuffix />
          )}
        </div>
      </CardText>
      <CombatRunSoldierList
        charId={charId}
        clientNow={clientNow}
        team="player"
        soldiers={playerSoldiers}
        title={displayName}
        float="left"
      />
      <CombatRunSoldierList
        charId={charId}
        clientNow={clientNow}
        team="enemy"
        soldiers={enemySoldiers}
        title={<ZM id={zone} />}
        float="right"
      />
      <div style={{clear: "both"}} />
    </div>
  )
}
// This is for use within CombatResult
export const CombatRunContent = containers.combat.CombatRun(
  CombatRunContentRender,
)

function CombatRunRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {zone} = props
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle
            text={<M id="title" values={{zone: <ZM id={zone} />}} />}
          />
        </ToolbarGroup>
      </Toolbar>
      <CombatRunContentRender {...props} />
    </div>
  )
}
export default containers.combat.CombatRun(Util.DumpProps(CombatRunRender))



// WEBPACK FOOTER //
// ./src/combat/CombatRun.js